/** Path the Fay page is mounted at in the host app. Both consuming apps serve
 *  Fay here, and every package deep-link path is built under it. If an app ever
 *  needs to mount Fay elsewhere, this becomes an argument to `usePackageRoute`
 *  rather than a constant. */
export const FAY_ROUTE_BASE = "/admin-oversight-agent";

/** Names of the Fay RUM browser actions. These are free text — the
 *  `fay.{track}.{operation}.{measure}` contract the `fay` repo enforces governs
 *  emitted backend metrics only and does not reach RUM. The shared `fay_` prefix
 *  is what lets a dashboard select the whole family in one query. */
export const FAY_RUM_ACTIONS = {
  uploadStarted: "fay_upload_started",
  uploadResult: "fay_upload_result",
  classificationDecision: "fay_classification_decision",
  findingsDisplayed: "fay_findings_displayed",
  findingTriaged: "fay_finding_triaged",
  findingFeedbackSubmitted: "fay_finding_feedback_submitted",
} as const;

/** Duration vital spanning the classification screen opening and the user's
 *  first confirm-or-clear decision. */
export const FAY_CLASSIFICATION_VITAL = "FayClassificationDecision";
